import { ReportAPI } from "@/api/report.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";

const reportApi = new ReportAPI();

const relatorioFrotaVeiculo = (
  tipo: number,
  cnpj: string,
  recaptcha: string,
  placa: string,
  numOrdem: number

): AxiosObservable<any> => {
  return reportApi.relatorioFrotaVeiculo(tipo, cnpj, recaptcha, placa, numOrdem);
};

const relatorioFrotaAutoInfracao = (
  tipo: number,
  cnpj: string,
  recaptcha: string,
  placa: string,
  dataInicio: string,
  dataFim: string,
  numOrdem: number

): AxiosObservable<any> => {
  return reportApi.relatorioFrotaAutoInfracao(
    tipo,
    cnpj,
    recaptcha,
    placa,
    dataInicio,
    dataFim,
    numOrdem
  );
};

const certificadoInclusaoVeiculo = (
  cnpj: string,
  placa: string,
  recaptcha: string,
  numOrdem: number
  
): AxiosObservable<any> => {
  return reportApi.certificadoInclusaoVeiculo(cnpj, placa, recaptcha, numOrdem);
};

const certificadoRegistro = (
  cnpj: string,
  recaptcha: string,
  numOrdem: number

): AxiosObservable<any> => {
  return reportApi.certificadoRegistro(cnpj, recaptcha, numOrdem);
};

export default {
  relatorioFrotaVeiculo,
  relatorioFrotaAutoInfracao,
  certificadoInclusaoVeiculo,
  certificadoRegistro
};
